module.exports = __webpack_public_path__ + "img/rapid-idp.99ff85d1.png";